import { Language } from 'ha/i18n';

const availableLanguages = [Language.en];

export default (lang: Language) => availableLanguages.includes(lang);
